import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ArrowLeft, ShoppingBag } from "lucide-react";
import { api } from "../lib/api";
import { useLang } from "../contexts/LanguageContext";
import { useCart } from "../contexts/CartContext";
import { toast } from "sonner";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t, lang } = useLang();
  const { addItem } = useCart();
  const [product, setProduct] = useState(null);

  useEffect(() => {
    api.get(`/products/${id}`).then((r) => setProduct(r.data)).catch(() => navigate("/shop"));
  }, [id, navigate]);

  if (!product) return <div className="min-h-screen flex items-center justify-center text-gray-500 font-mono-tech text-xs">LOADING…</div>;

  const handleAdd = () => {
    addItem({ item_id: product.id, item_type: "product", title: product.title, cover: product.cover, price: product.price });
    toast.success(lang === "es" ? "Añadido al carrito" : "Added to cart");
  };

  return (
    <div data-testid="product-detail-page" className="bg-[var(--monzal-bg)] min-h-screen">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 pt-10">
        <Link to="/shop" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] font-display text-gray-400 hover:text-[var(--monzal-gold)]">
          <ArrowLeft size={14} /> {t("detail.back")}
        </Link>
      </div>
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 pt-8 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-7">
          <div className="aspect-square bg-black overflow-hidden border border-white/5">
            <img src={product.cover} alt={product.title} className="w-full h-full object-cover" />
          </div>
        </div>
        <div className="lg:col-span-5">
          <div className="overline capitalize">{product.category}</div>
          <h1 className="font-display font-light text-3xl lg:text-5xl text-white tracking-tight mt-3" data-testid="product-title">{product.title}</h1>
          <div className="mt-6 text-4xl font-display font-light text-[var(--monzal-gold)]" data-testid="product-price">
            ${product.price.toLocaleString()}
            <span className="text-sm text-gray-500 ml-2 font-mono-tech">{product.currency}</span>
          </div>
          <p className="text-gray-300 mt-8 leading-relaxed">{product.description}</p>
          <div className="mt-8 flex items-center gap-3">
            <span className="tag-tech">STOCK · {product.stock}</span>
          </div>
          <div className="mt-10 flex gap-3">
            <button data-testid="product-add-cart-btn" onClick={handleAdd} className="btn-emerald-glow">
              <ShoppingBag size={14} /> {t("shop.addToCart")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
